export default __webpack_public_path__ + "static/media/MyPlanimg1cd3dda33.ad5ba1ac.jpg";